export enum CryptocurrencyIncomeTypes {
    CRYPTOCURRENCY = 'cryptocurrency',
  }
  